import { useMutation } from '@apollo/client';
import { useEffect } from 'react';

import TagClickedMutation from './TagClickedMutation.graphql';
import TagViewedMutation from './TagViewedMutation.graphql';

export function useLogTagClickedMutation() {
  const [logTagClicked] = useMutation(TagClickedMutation);

  return logTagClicked;
}

export function useLogTagViewed(tagName) {
  const [logTagViewed] = useMutation(TagViewedMutation);

  useEffect(() => {
    logTagViewed({
      variables: {
        tag: tagName,
      },
    });
  }, [logTagViewed, tagName]);
}
